import 'slick-carousel'
import jQuery from 'jquery'
import log from 'salvo-lite/log'

class Slick {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this.options = Object.assign({
            arrows: false,
            dots: false,
            autoplay: false,
            infinite: true,
            draggable: false,
            slidesToShow: 1,
            mobileOnly: false,
            swipe: true,
            dontInit: false,
            showAbove: null,
            showBelow: null
        }, JSON.parse(this._elem.dataset.slick) || '{}')

        this._initialized = false

        if (this.options.mobileOnly) {
            this.options.showBelow = 769
        }

        if (!this.options.dontInit) {
            this.init()
        }
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
    }

    filterSlides (filter) {
        if (this._initialized) {
            jQuery(this._elem).slick('slickUnfilter')
            jQuery(this._elem).slick('slickFilter', filter)
        }
    }

    init () {
        if (this.options.showAbove && window.innerWidth <= this.options.showAbove) {
            return false
        }

        if (this.options.showBelow && window.innerWidth >= this.options.showBelow) {
            return false
        }

        jQuery(this._elem).on('init', (e, slick) => {
            this._initialized = true
            this._elem.classList.add('show-slider')
            this._elem.dispatchEvent(new Event('sliderRendered'))
            let vid = slick.$slides.length ? slick.$slides[0].querySelector('video') : false
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
            let goToBtns = this._elem.querySelectorAll('[data-slick-go-to]')

            if (goToBtns) {
                for (var i = 0; i < goToBtns.length; i++) {
                    const btn = goToBtns[i]
                    const index = parseInt(btn.dataset.slickGoTo)
                    if (btn.dataset.defaultSlide !== undefined) this._goToSlide(parseInt(btn.dataset.slide))
                    btn.addEventListener('click', e => {
                        this._goToSlide(index)
                    })
                }
            }
            let container = document.querySelector('#shopify-section-template-lookbook')
            if (container) {
                let lookBookBtns = container.querySelectorAll('[data-slick-go-to]')
                if (lookBookBtns) {
                    for (var l = 0; l < lookBookBtns.length; l++) {
                        const btn = lookBookBtns[l]
                        const index = parseInt(btn.dataset.slickGoTo)
                        if (btn.dataset.defaultSlide !== undefined) this._goToSlide(parseInt(btn.dataset.slide))
                        btn.addEventListener('click', e => {
                            this._goToSlide(index)
                        })
                    }
                }
            }
        })

        jQuery(this._elem).not('.slick-initialized').slick(this.options)

        jQuery(this._elem).on('beforeChange', (e, slick, curSlide, nextSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.pause()
            }
        })

        jQuery(this._elem).on('afterChange', (e, slick, curSlide) => {
            let vid = slick.$slides[curSlide] ? slick.$slides[curSlide].querySelector('video') : null
            if (vid) {
                vid.play()
                vid.removeAttribute('poster')
            }
        })
    }
    _goToSlide (index) {
        jQuery(this._elem).slick('slickGoTo', index)
        if (document.querySelector('.template-addresses')) {
            const announcmentHeight = document.querySelector('.announcement').offsetHeight
            const headerHeight = document.querySelector('header').offsetHeight
            const heroHeight = document.querySelector('.account__dashboard').offsetHeight
            const top = (heroHeight + announcmentHeight) - headerHeight
            window.scrollTo({
                top: top,
                left: 0,
                behavior: 'smooth'
            })
        }
    }
}

export default Slick



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Slick.js